import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Grid,
  Button,
  Box,
  Typography,
  Card,
  CardContent,
  IconButton,
  Tooltip,
} from "@mui/material";
import useMapUser from "../../../hooks/useMapUser";
import { Plus, Edit2 } from "react-feather";
import styled from "@emotion/styled";

const StyledTable = styled("table")`
  width: 100%;
  border-collapse: collapse;
  & th {
    text-align: left;
    padding: 16px;
    background: #f8f9fa;
    color: #495057;
    font-weight: 600;
    font-size: 0.85rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-bottom: 2px solid #e9ecef;
  }
  & td {
    padding: 16px;
    border-bottom: 1px solid #e9ecef;
    font-size: 0.9rem;
    color: #212529;
  }
  & tr:hover {
    background-color: #f1f3f5;
  }
`;

function MapUserListPage() {
  const { getAllMapUsers, mapUsers, isLoading } = useMapUser();
  const navigate = useNavigate();

  useEffect(() => {
    getAllMapUsers({
      filters: [],
      pagination: {
        pageNumber: 1,
        pageSize: 100,
      },
      sortFields: [],
    });
  }, []);

  const handleEdit = (user) => {
    navigate("/cpanel/map-user/edit", { state: { id: user.userId } });
  };

  return (
    <Box p={6} bgcolor="#f4f7f6" minHeight="100vh">
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={6}>
            <Box>
              <Typography variant="h3" fontWeight="bold" color="primary">
                User Mappings
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Manage Admin-to-Franchise and RadUser distribution
              </Typography>
            </Box>
            <Button
              variant="contained"
              color="primary"
              startIcon={<Plus size={18} />}
              onClick={() => navigate("/cpanel/map-user/add")}
              sx={{ borderRadius: "8px", px: 4, py: 1.5, boxShadow: "0 4px 12px rgba(0,0,0,0.15)" }}
            >
              Add Mapping
            </Button>
          </Box>
          <Card
            sx={{
              borderRadius: "16px",
              boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
              overflow: "hidden",
            }}
          >
            <CardContent sx={{ p: 0 }}>
              {isLoading ? (
                <Box display="flex" justifyContent="center" py={10}>
                  <Typography color="textSecondary">Loading mapping records...</Typography>
                </Box>
              ) : (
                <StyledTable>
                  <thead>
                    <tr>
                      <th>Admin User</th>
                      <th>Franchises</th>
                      <th>Distributed Users</th>
                      <th style={{ textAlign: "center" }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {mapUsers.length === 0 ? (
                      <tr>
                        <td colSpan={4} style={{ textAlign: "center", py: 10, color: "#adb5bd" }}>
                          No mapping records found.
                        </td>
                      </tr>
                    ) : (
                      mapUsers.map((item, index) => (
                        <tr key={index}>
                          <td style={{ fontWeight: "600" }}>
                            {item.adminName || item.adminUsername || item.userId}
                          </td>
                          <td>{item.franchiseIds?.length || 0} Franchises</td>
                          <td>{item.radUserIds?.length || 0} Users</td>
                          <td style={{ textAlign: "center" }}>
                            <Tooltip title="Edit Mapping">
                              <IconButton
                                color="primary"
                                size="small"
                                onClick={() => handleEdit(item)}
                                sx={{
                                  bgcolor: "primary.lightest",
                                  "&:hover": { bgcolor: "primary.light" },
                                }}
                              >
                                <Edit2 size={16} />
                              </IconButton>
                            </Tooltip>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </StyledTable>
              )}
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
}

export default MapUserListPage;
